import { getDept, getUserList, treeselect } from '@/api/system/dept';

export const treeSelectMixin = {
  data() {
    return {
      mixin_deptId: undefined,
      // 部门树选项
      deptOptions: [
        {
          id: 0,
          label: '',
          weight: 0,
          children: []
        }
      ],
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id', weight: 'weight' },
      userList: [],
      curSelDeptInfo: {}
    };
  },
  methods: {
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeselect().then((response) => {
        this.deptOptions = response.data;
      });
    },
    getDeptInfo(id, func) {
      getDept(id).then((response) => {
        this.curSelDeptInfo = response.data;
        if (func) {
          func();
        }
      });
    },
    getUserListItem() {
      const deptId = this.fromStaff && this.fromStaff.keyTeam;
      if (deptId) {
        getUserList({ deptId: deptId, status: 0 }).then((res) => {
          if (res.code === 200) {
            this.userList = res.rows;
          }
        });
      }
    },
    // 房源列表
    handleOption(e) {
      if (e) {
        const deptId = this.mixin_deptId;
        if (deptId !== undefined) {
          getUserList({ deptId: deptId, status: 0 }).then((res) => {
            if (res.code === 200) {
              this.userList = res.rows;
            }
          });
        } else {
          this.userList = [];
        }
      }
    },
    // 钥匙交接弹窗
    handleOptionkeys(e) {
      if (e) {
        const deptId = this.KeysList.collectKeyTeamId;
        if (deptId !== undefined) {
          getUserList({ deptId: deptId, status: 0 }).then((res) => {
            if (res.code === 200) {
              this.userList = res.rows;
            }
          });
        } else {
          this.userList = [];
        }
      }
    },
    // 编辑人员弹窗
    handleOptionedit(e) {
      if (e) {
        const deptId = this.fromStaff.keyTeam;
        if (deptId !== undefined) {
          getUserList({ deptId: deptId, status: 0 }).then((res) => {
            if (res.code === 200) {
              this.userList = res.rows;
            }
          });
        } else {
          this.userList = [];
        }
      }
    },
    // 客源列表
    handleOptiontourist(e) {
      if (e) {
        const deptId = this.form.deptId;
        if (deptId !== undefined) {
          getUserList({ deptId: deptId, status: 0 }).then((res) => {
            if (res.code === 200) {
              this.userList = res.rows;
            }
          });
        } else {
          this.userList = [];
        }
      }
    },
    // 客源转维护人
    handleOptiontourist_maintainer(e) {
      if (e) {
        const deptId = this.maintainer.deptId;
        if (deptId !== undefined) {
          getUserList({ deptId: deptId, status: 0 }).then((res) => {
            if (res.code === 200) {
              this.userList = res.rows;
            }
          });
        } else {
          this.userList = [];
        }
      }
    },
    // 业绩报表
    handleOption_achiev(e) {
      if (e) {
        const deptId = this.queryParam.teamId;
        if (deptId !== undefined) {
          getUserList({ deptId: deptId, status: 0 }).then((res) => {
            if (res.code === 200) {
              this.userList = res.rows;
            }
          });
        } else {
          this.userList = [];
        }
      }
    },
    // 业绩榜单
    handleOption_achievment(e) {
      if (e) {
        const deptId = this.form.teamId;
        if (deptId !== undefined) {
          getUserList({ deptId: deptId, status: 0 }).then((res) => {
            if (res.code === 200) {
              this.userList = res.rows;
            }
          });
        } else {
          this.userList = [];
        }
      }
    },
    // 树变了就清空人列表
    handleChangeTree(val) {
      this.getDeptInfo(val, () => {
        // console.log(this.curSelDeptInfo)
        // deptLev 部门等级（1.门店，2.团队或小组）
        const DEPT = this.curSelDeptInfo;
        if (DEPT && DEPT.deptLev === '1') {
          this.form.storeId = val; // 门店ID（维护人
          this.form.teamId = undefined;
        } else if (DEPT && DEPT.deptLev === '2') {
          this.form.teamId = val; // 部门ID（维护人）
          this.form.storeId = undefined;
        }
      });

      this.form.accendantId = undefined;
    },
    handleSelectTree(selectedKeys, info) {
      // console.log('selected', selectedKeys, info.value, info.label, info)
    },
    handleChangeTreesignId() {
      this.form.signId = undefined;
    },
    handleChangeTreekeys() {
      this.KeysList.collectKeyUserId = undefined; // 钥匙交接
    },
    handleChangeTreeedit() {
      this.fromStaff.ketemp = undefined; // 编辑人员
    },
    handleChangeTreeeMain() {
      this.maintainer.accendantId = undefined; // 客源转维护人
    },
    handleChangeTree_achiev() {
      this.queryParam.userId = undefined; // 业绩报表
    },
    handleChangeTree_achievment() {
      this.form.userId = undefined; // 业绩榜单
    }
  },
  created() {
    this.getTreeselect();
  }
};
